import * as React from "react"

function MinusToggle(props) {
  return (
    <svg
    width={40}
    height={40}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      stroke="#071D34"
      strokeWidth={3}
      strokeLinecap="round"
      d="M4.5 21.5h30"
    />
  </svg>
  )
}

export default MinusToggle